import Breadcrumbs from '../components/Breadcrumbs';
import Link from '../components/Link';
import PrintButton from '../components/PrintButton';
import WorksheetSheet from '../components/worksheets/WorksheetSheet';
import NotFoundPage from './NotFoundPage';
import { CONTENT_CLASSES, WORKSHEET_CLASSES } from '../constants/classNames';
import { ROUTES } from '../constants/config';
import { WORKSHEETS, findWorksheetBySlug } from '../data/worksheets';
import { buildWorksheetAnswersPath, buildWorksheetPath } from '../utils/routeUtils';
import { joinClassNames } from '../utils/classNameUtils';
import '../styles/ContentPage.css';
import '../styles/Worksheet.css';

/**
 * One free printable worksheet, with instructions for children and notes for grown-ups.
 * Only the instructions and the sheet itself are printed.
 */
export default function WorksheetPage({ slug }) {
  const worksheet = findWorksheetBySlug(slug);
  if (!worksheet) return <NotFoundPage />;
  const otherWorksheets = WORKSHEETS.filter((other) => other.slug !== slug);

  return (
    <article className={joinClassNames(CONTENT_CLASSES.root, WORKSHEET_CLASSES.page)}>
      <Breadcrumbs
        trail={[
          { label: 'Lab', path: ROUTES.LAB },
          { label: 'Parents & teachers', path: ROUTES.PARENTS },
          { label: worksheet.title, path: buildWorksheetPath(worksheet) },
        ]}
      />
      <header className={CONTENT_CLASSES.hero}>
        <h1 className={CONTENT_CLASSES.heading}>{worksheet.title}</h1>
        <p className={CONTENT_CLASSES.meta}>
          Free printable worksheet · Ages {worksheet.ages} · About {worksheet.minutes} minutes
        </p>
        {worksheet.intro.map((paragraph) => (
          <p key={paragraph.slice(0, 40)} className={CONTENT_CLASSES.text}>
            {paragraph}
          </p>
        ))}
      </header>

      <div className={joinClassNames(WORKSHEET_CLASSES.actions, WORKSHEET_CLASSES.noPrint)}>
        <PrintButton label="Print or save as PDF" />
        {worksheet.hasAnswers && <Link to={buildWorksheetAnswersPath(worksheet)}>Answer key</Link>}
        <Link to={ROUTES.LAB}>Open the lab</Link>
      </div>

      <WorksheetSheet worksheet={worksheet} />

      <section className={joinClassNames(CONTENT_CLASSES.section, WORKSHEET_CLASSES.noPrint)}>
        <h2 className={CONTENT_CLASSES.sectionTitle}>Notes for parents and teachers</h2>
        {worksheet.teacherNotes.map((paragraph) => (
          <p key={paragraph.slice(0, 40)} className={CONTENT_CLASSES.text}>
            {paragraph}
          </p>
        ))}
      </section>

      <section className={joinClassNames(CONTENT_CLASSES.section, WORKSHEET_CLASSES.noPrint)}>
        <h2 className={CONTENT_CLASSES.sectionTitle}>More free worksheets</h2>
        <ul className={CONTENT_CLASSES.list}>
          {otherWorksheets.map((other) => (
            <li key={other.slug} className={CONTENT_CLASSES.listItem}>
              <Link to={buildWorksheetPath(other)}>{other.title}</Link>
            </li>
          ))}
        </ul>
        <p className={CONTENT_CLASSES.text}>
          <Link to={ROUTES.PARENTS}>Lesson ideas and tips for parents and teachers</Link>
        </p>
      </section>
    </article>
  );
}
